module.exports = __webpack_public_path__ + "media/12_25.5781a632.wav";